<template>
  <section class='leaveStu'>
    <Row>
      <Breadcrumb>
        <BreadcrumbItem>媒体发布</BreadcrumbItem>
        <BreadcrumbItem>广告管理</BreadcrumbItem>
      </Breadcrumb>
    </Row>
    <Row xs="20" sm="16" md="12" lg="8">
      <ul class='conheadRight'>
        <i-button type="error" @click='getId(-1)'>添加广告</i-button>
      </ul>
    </Row>
    <Row id='pdData2' class='pdData'>
      <div v-for='(item, index1) in gatype' class='itempd' :class='[index1 == curIndex1 ? "active" : ""]'
        :key="item.type" @click='tabPD(index1)' v-if="item">{{ item }}</div>
    </Row>
    <section class='tabelContent'>
      <tablePage border :queryData="queryData" :searchParam='searchParam' :issearch='issearch'>
      </tablePage>
    </section>

    <Modal v-model="edit" title='新增/修改' width='900px' :mask-closable='false'>

      <Form label-position="top" :model='formItem' ref='formCustom'>
        <FormItem label="类型">
          <ul class='showlist'>
            <li :class="[curIndex1 == index ? 'active' : '']" @click='curIndex1 = index' v-for="(item, index) in gatype"
              :key="index" v-if="item != '全部'">
              <img src="/dist/img/ad_signal_1@2x.png" alt="">
              <p>{{ item }}</p>
            </li>
          </ul>
        </FormItem>




        <Row :gutter="16">
          <Col span="12">
          <FormItem label="名称">
            <Input v-model="formItem.name" type='text'></Input>
          </FormItem>

          </Col>
          <Col span="12">
          <FormItem label="排序（本排序为出现在新闻列表的第几条显示广告）" v-if='curIndex == 4'>
            <InputNumber v-model="formItem.sort" style='width:100%;'></InputNumber>
          </FormItem>
          <FormItem label="排序" v-else>
            <InputNumber v-model="formItem.sort" style='width:100%;'></InputNumber>
          </FormItem>
          </Col>
        </Row>
        <Row :gutter="16">
          <Col span="12">
          <Form-item label="有效时间">
            <Date-picker type="daterange" v-model='formItem.rangetime' format="yyyy-MM-dd" style="width: 100%">
            </Date-picker>
          </Form-item>
          </Col>
          <Col span="12">
          <Form-item label="展示状态">

            <i-switch v-model="showState" size="large">

              <span slot="close">下架</span>
              <span slot="open">上架</span>
            </i-switch>
          </Form-item>
          </Col>
        </Row>
        <Form-item label="所属栏目" prop="source" v-if='curIndex == 3 || curIndex == 4'>
          <Select v-model="formItem.itemid">
            <Option v-for="items in rootData" :value="items.guid" :key="items.guid">{{ items.name }}
            </Option>
          </Select>
        </Form-item>
        <!-- <FormItem label="备注" >
            	<Input v-model="formItem.name" type='textarea' ></Input>
            </FormItem> -->



        <FormItem label="跳转地址">
          <Input v-model="formItem.url" type='text'></Input>
        </FormItem>
        <FormItem label="上传图片">
          <!-- <input type="hidden" v-model='formItem.pic'> -->

          <upImg @upImglist='upImglist' :extradata='selfIcon' :defaultimg='formItem.pic' :defaultname='selfIcon.name'>
          </upImg>

          <p style='color:#e22a1c' v-if='curIndex == 1'>图片尺寸：1030*330</p>
          <p style='color:#e22a1c' v-if='curIndex == 2'>图片尺寸：1125*2436</p>
          <p style='color:#e22a1c' v-if='curIndex == 3'>图片尺寸：1125*614</p>
          <p style='color:#e22a1c' v-if='curIndex == 4'>图片尺寸：1030*240</p>
          <p style='color:#e22a1c' v-if='curIndex == 6'>图片尺寸：400*308</p>
          <p style='color:#e22a1c' v-if='curIndex == 7'>图片尺寸：750*460</p>
          <!-- <p style='color:#e22a1c' v-if='curIndex==8'>图片尺寸：</p> -->
        </FormItem>


      </Form>
      <div slot="footer" style='position:relative;clear:both'>

        <Button type="error" @click='removeItem' class='remove' icon="md-trash"
          v-if='this.formItem.id != ""'>删除</Button>
        <Button type="default" @click='edit = false' icon="md-close">取消</Button>
        <Button type="info" @click='update' icon="md-checkmark-circle-outline">保存</Button>
      </div>
    </Modal>
    <bemodal :reloadtmp='reloadTmep' :formdata='formData' @reloadModalData='reloadTable'></bemodal>
  </section>
</template>

<script>
import getDates from '../utils/index'
import tablePage from './tablePage'
import bemodal from './formItemNoSch'
import upImg from './upImgnew'
export default {
  name: 'newslist',
  components: {
    tablePage,
    bemodal,
    upImg
  },
  data () {
    return {
      curIndex: 1,
      curStuInfo: {},
      edit: false,
      initformItem: {

      },
      showState: true,
      formItem: {
        name: '',
        sort: 1,
        pic: '',
        url: '',
        itemid: '',
        guid: '',
        type: '1',
        remark: '',
        rangetime: [],
      },
      selfIcon: {
        pictype: 'banner',
        name: 'pic',
        size: '1125*614',
      },
      smodal: false,
      reloadTmep: -1,
      initformData: [],
      formData: [
        ['banner/getId', 'banner/save', 'banner/delete'],
        [{
          type: 'input',
          title: '广告名称',
          name: 'name',
          model: '',
          block: true,
        },
        {
          type: 'selectRoot',
          title: '所属栏目',
          name: 'itemid',
          model: '',
          chilrend: [],
          block: true,
        },
        {
          type: 'input',
          title: '超链接',
          name: 'url',
          model: '',
          block: true,
        },
        {
          type: 'numberInput',
          title: '排序',
          name: 'sort',
          model: 1,
          block: true,
        },
        {
          type: 'uploadimg',
          title: '封面',
          name: 'pic',
          pictype: {
            type: 'banner'
          },
          model: '',
          block: true,
        },
        {
          type: 'input',
          title: '备注',
          name: 'remark',
          model: ''
        },


        {
          type: 'hidden',
          children: [{
            name: 'guid',
            model: ''
          }]
        }
        ]
      ],
      queryData: ['banner/getQueryList?type=0',
        [{
          title: '图片',
          key: '',
          width: 100,
          render: (h, params) => {

            return h('viewer', [
              h('img', {
                style: { //设置样式
                  display: 'block',
                  width: '49px',
                  height: '27px',
                },
                attrs: { //设置属性
                  src: params.row.pic
                }
              })
            ])

          }

        },
        {
          title: '展现类型',
          key: 'type',
          width: 120,
          render: (h, params) => {
            var arr = ['APP首页幻灯', 'APP开机广告', '融发布幻灯', 'APP横幅广告', '视频广告', '惠生活广告', '新主页广告', '网站横幅广告']
            var _type = Number(params.row.type)
            return h('span', arr[_type - 1])
          }
        },
        {
          title: '排序',
          key: 'sort',
          width: 80,
          align: 'center',
        },
        {
          title: '显示状态',
          key: 'isenable',
          width: 110,
          render: (h, params) => {
            var _isshow = params.row.isenable == 1 ? '展示中' : '已下架'
            if (params.row.isenable == 1) {
              return h('span', {
                style: {
                  color: " #00d186",
                },
              }, _isshow)
            } else {
              return h('span', _isshow)
            }

          }
        },
        {
          title: '有效时间',
          key: 'isenable',
          align: 'center',
          render: (h, params) => {
            var _isshow = params.row.begintime + '~' + params.row.endtime

            return h('span', _isshow)


          }
        },
        {
          title: '名称',
          key: 'name',
          render: (h, params) => {
            return h('span', decodeURI(params.row.name))
          }
        },

        {
          title: '链接地址',
          key: 'url',
        },
        {
          title: '操作',
          slot: 'action',
          width: 100,
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h('span', {
                style: {
                  display: 'inline-block',
                  width: '60px',
                  height: '25px',
                  background: '#2db7f5',
                  borderRadius: '6px',
                  textAlign: 'center',
                  lineHeight: '25px',
                  color: '#fff',
                  fontSize: '12px',
                  cursor: 'pointer',
                  userSelect: 'none'
                },
                on: {
                  click: () => {
                    this.curStuInfo = params.row
                    this.getId(params.row.guid)



                  }
                }
              }, '编辑')
            ])
            // <span class='do' @click="show(index,row)">编辑</span>
          }
        }

        ]
      ],
      searchParam: {
        name: '',
        itemid: '',
      },
      issearch: -1,
      rootData: [],
      storeimg: [],
      gatype: ['全部', '小程序首页幻灯', '学习顶部幻灯片'],
      curIndex1: 0,
    }
  },
  mounted () {
    this.initformData = JSON.parse(JSON.stringify(this.formData[1]))
    this.getrootData()

  },
  methods: {
    tabPD (index) {
      var that = this
      this.curIndex1 = index
      this.queryData[0] = 'banner/getQueryList?type=' + index
      this.searchData()
    },
    update (id) {
      var that = this

      var picstr = []
      if (this.storeimg.length > 0 && typeof (this.storeimg[0]) != 'number') {
        var storeimg = this.storeimg[0]['children']
        storeimg.map(function (val, index) {
          picstr.push(val['pic'])
        })
      } else {
        picstr.push(this.formItem.pic)
      }

      if (picstr.length == 0) {
        that.$Message.info('请上传图片')
        return false;
      }
      if (this.formItem.name == '') {
        that.$Message.info('请填写广告名称')
        return false;
      }
      if (this.curIndex == 3 && this.formItem.itemid == '') {
        that.$Message.info('请选择所属类别')
        return false;
      }
      if (this.curIndex != 3 && this.curIndex != 4) {
        this.formItem.itemid = ''
      }

      var param = {
        guid: this.formItem.guid,
        type: this.curIndex1,
        name: this.formItem.name,
        sort: this.formItem.sort,
        url: this.formItem.url,
        pic: picstr.join(','),
        itemid: this.formItem.itemid,
        remark: '',
        begintime: this.formateTime(this.formItem.rangetime[0], 1),
        endtime: this.formateTime(this.formItem.rangetime[1], 1),
        isenable: this.showState ? 1 : 0
      }
      if (param['pic'] == '') {
        that.$Message.info('请上传图片')
        return false;
      }


      this.axios.post('banner/save', param).then(res => {


        if (res.success) {
          that.searchData()
          that.edit = false
          that.$Message.success(res.msg)
          that.storeimg = []
        } else {
          that.$Message.error(res.msg)
        }
      })


    },
    removeItem () {
      var that = this

      this.axios.post('banner/delete', {
        id: this.formItem.guid
      }).then(res => {


        if (res.success) {
          that.searchData()
          that.edit = false
          that.$Message.success(res.msg)
        } else {
          that.$Message.error(res.msg)
        }
      })
    },
    getrootData () {
      var that = this
      that.axios.get('dic/getQueryList', {
        params: {
          length: -1,
          pid: '0',
          rootid: 'news'
        }
      }).then(res => {

        that.rootData = res.data
      })
    },
    formateTime (data, type) {
      if (!data) {
        return ''
      }
      var d = new Date(data);
      var month = (d.getMonth() + 1) > 9 ? d.getMonth() + 1 : '0' + (d.getMonth() + 1)
      var date = d.getDate() > 9 ? d.getDate() : '0' + d.getDate()
      var hours = d.getHours() > 9 ? d.getHours() : '0' + d.getHours()
      var minutes = d.getMinutes() > 9 ? d.getMinutes() : '0' + d.getMinutes()
      var seconds = d.getSeconds() > 9 ? d.getSeconds() : '0' + d.getSeconds()
      var time = d.getFullYear() + '-' + month + '-' + date + ' ' + hours + ':' + minutes
      ////console.log(data, time)
      if (type == 1) {
        return d.getFullYear() + '-' + month + '-' + date
      }
      return time
    },
    getId (guid) {

      this.edit = true

      this.formItem = {
        name: '',
        sort: 1,
        pic: '',
        url: '',
        itemid: '',
        guid: '',
        type: '1',
        remark: '',
      }

      this.$set(this.formItem, 'pic', '')
      this.storeimg = []
      var that = this

      if (guid != '-1') {
        this.axios.get('banner/getId', {
          params: {
            id: guid
          }
        }).then(res => {

          that.formItem['name'] = res.data.name
          that.formItem['sort'] = res.data.sort
          that.formItem['url'] = res.data.url
          that.formItem['itemid'] = res.data.itemid
          that.formItem['guid'] = res.data.guid
          that.formItem['pic'] = res.data.pic
          that.curIndex1 = that.formItem['type'] = res.data.type
          that.showState = res.data.isenable == 1 ? true : false
          that.formItem['rangetime'] = [res.data.begintime, res.data.endtime]

        })
      }

    },
    searchData () {
      this.issearch = Math.random()
    },

    reloadTable () {
      this.issearch = Math.random()
    },
    upImglist (a, b, c) {

      var that = this
      var _name = a.name
      var pics = a.pics
      var arr = []
      var clipArr = []
      for (var i = 0; i < pics.length; i++) {
        var item = pics[i]['response']['url']
        if (i == 0) {
          that.formItem.pic = item
        }
        var pic = pics[i]['response']['url']
        var picsmall = pics[i]['response']['url']
        var obj = {
          pic: pic,
          picsmall: picsmall,
        }
        clipArr.push(picsmall)
        arr.push(obj)
      }

      var storeImg = this.storeimg
      if (storeImg.length > 0) {
        for (var j = 0; j < storeImg.length; j++) {
          switch (storeImg[j]['name']) {
            case _name:
              storeImg[j]['children'] = arr
              break;
            default:
              storeImg.push({
                name: _name,
                children: arr
              })
              break;
          }
        }
      } else {
        storeImg.push({
          name: _name,
          children: arr
        })
      }

      this.storeimg = storeImg


    },
  }
}
</script>

<style scoped>
.tabelContent {
  margin-top: 20px;
}

.leaveStu {
  flex: 1;
  padding-right: 25px !important;
  /* overflow: scroll; */
  padding-bottom: 50px;
  padding-top: 20px;
  overflow-x: hidden;
}

.leaveStu .ivu-row:first-of-type {
  margin-top: 5px;
}

.leaveStu .ivu-row {
  margin-top: 20px;
  /* 	overflow:hidden; */
  position: relative;
}

.leaveStu .ivu-col {
  margin-right: 10px;
  /* float:left; */
}

.leaveStu .ivu-col:last-of-type {
  float: left;
  margin-left: 10px;
  /* position:absolute;
		right:0px; */
}

.demo-upload-list {



  border: 1px solid transparent;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
  position: relative;
  overflow: hidden;
  margin-right: 4px;
  margin-bottom: 5px;
}

.demo-upload-list img {
  width: 40px;
  height: 40px;
  float: left;
  margin-right: 15px;
}

.demo-upload-list span {
  line-height: 40px;
  font-size: 12px;
  float: left;
}

.demo-upload-list-cover {
  display: none;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, .6);
}

.demo-upload-list:hover .demo-upload-list-cover {
  display: block;
}

.demo-upload-list-cover i {
  color: #fff;
  font-size: 20px;
  cursor: pointer;
  margin: 0 10px;
  line-height: 40px;

}

#hwSchool {
  position: relative;
}

#hwSchool .ivu-tree {
  position: absolute;
  top: 33px;
  left: 0px;
  background: #fff;
  z-index: 1000;
  width: 300px;
  height: 300px;
  border: 1px solid #dcdee2;
  border-top: 0 none;
  overflow-y: scroll;
  overflow-x: hidden;
  padding-left: 10px;
}

.modalUl {
  width: 100%;
  display: flex;
  justify-content: space-between;


}

.modalUl li {
  list-style: none;

}

.modalUl>li:first-of-type {
  width: 35%;
  height: 100%;
  height: 400px;
  overflow-y: scroll;
  overflow-x: hidden;
}

.modalUl>li:last-of-type {
  flex: 1;
  padding-left: 30px;
}

.treeContent {}

.hwImgCon {
  margin-top: 10px;

}

.hwImgCon img {
  width: 55px;
  height: 55px;
  border-radius: 5px;
}

.conheadRight {
  float: right;
}

.showlist {
  display: flex;
  justify-content: space-around;
}

.showlist li {
  list-style: none;
  border: 3px solid #fff;
  cursor: pointer;
}

.showlist li img {
  width: 100px;
  height: auto;
}

.showlist li p {
  text-align: center;
}

.showlist li.active {
  border: 3px solid #e22a1c
}

.remove {
  float: left;
}

#pdData {
  display: flex;
  justify-content: flex-start;

}

.pdData {
  display: flex;
  justify-content: flex-start;
  list-style: none;
  flex-wrap: wrap;
}

.itempd {

  height: 32px;
  line-height: 32px;
  border-radius: 20px;
  padding: 0 15px;
  font-size: 14px;
  margin-right: 10px;
  cursor: pointer
}

.itempd.active {
  background-color: #00d186;
  border-color: #00d186;
  color: #fff;
}
</style>
